module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gh-87686ea032052059cd6d76ab314a264a.svg";